import {Redirect, Route} from "react-router-dom";
import {HelpAbility} from "helpers/HelpAbility";

const PrivateRoute = ({component: Component, ...rest}) => {
    let myAbilities = HelpAbility();
    console.log({rest});
    return (
        <Route exact={rest.exact} path={rest.path}>
            {myAbilities.can(rest) ? <Component/> : <Redirect to="/login"/>}
        </Route>
    );
};

export default PrivateRoute;
